<template>
	<div class="userPayment w-100">
		<!-- DESKTOP -->
		<template v-if="!isMobile">
			<b-tabs class="tabs-payment">
				<b-tab active>
					<template v-slot:title>
						<FileDocumentOutlineIcon />
						<span>{{ $t('userDashboard.paymentHistory.paymentHistory') }}</span>
					</template>
					<div class="tab-tooltip row">
						<b-col cols="12" md="6">
							<div class="wrap-input-search">
								<b-form-input
									class="input-search"
									:placeholder="$t('Find the receipt number')"
									v-model="searchQuery"
								></b-form-input>
							</div>
						</b-col>
						<b-col cols="12" md="6" class="text-right">
							<b-dropdown class="input-choose" no-flip>
								<template v-slot:button-content>
									<span>
										{{ $t('sort by') }}
										<ChevronDownIcon />
									</span>
								</template>
								<b-dropdown-item
									v-for="(order, k) in orderByFilters"
									:key="k"
									@click="fetchUserPayments(order.key)"
									>{{ order.value }}</b-dropdown-item
								>
							</b-dropdown>
						</b-col>
					</div>
					<div
						v-if="userPayments.length == 0 || loading"
						class="wrap-list text-center"
					>
						<b-spinner
							v-if="loading"
							label="Loading..."
							variant="'primary'"
						></b-spinner>
						<p v-else>{{ $t('payment.youHaveNoPayments') }}</p>
					</div>
					<div v-else class="wrap-list">
						<b-table sticky-header :fields="fields" :items="userPayments">
							<template v-slot:cell(id)="data">
								<div>{{ data.item.order_id }}</div>
							</template>
							<template v-slot:cell(created_at_day)="data">
								<div>
									{{
										data.item.updated_at
											| formatDate($router.currentRoute.params.lang)
									}}
								</div>
							</template>
							<template v-slot:cell(created_at_time)="data">
								<div>
									{{
										data.item.updated_at
											| formatHour($router.currentRoute.params.lang)
									}}
								</div>
							</template>
							<template v-slot:cell(total_amount)="data">
								<div>
									{{
										parseFloat(data.item.total_amount).toLocaleString('th-TH')
									}}
									{{ $t('baht') }}
								</div>
							</template>
							<template v-slot:cell(status)="data">
								<div v-if="data.item.status == 1" class="success">
									{{ $t('payment.statuses.created') }}
								</div>
								<div v-else-if="data.item.status == 2" class="pending">
									{{ $t('payment.statuses.processing') }}
								</div>
								<div v-else-if="data.item.status == 3" class="success">
									{{ $t('payment.statuses.completed') }}
								</div>
								<div v-else-if="data.item.status == 4" class="unsuccess">
									{{ $t('payment.statuses.fail') }}
								</div>
								<div v-else-if="data.item.status == 6" class="success">
									{{ $t('payment.statuses.refund') }}
								</div>
								<div v-else-if="data.item.status == 7" class="success">
									{{ $t('payment.statuses.awaitingPayment') }}
								</div>
							</template>
							<template v-slot:cell(tooltip)="data">
								<div class="success">
									<span
										v-if="data.item.status == 3"
										@click="openSendDialog(data.item.id)"
									>
										<SendOutlineIcon />
									</span>

									<span
										v-if="
											data.item.status == 2 ||
												data.item.status == 4 ||
												data.item.status == 1 ||
												data.item.status == 7
										"
										@click="tryPayment(data.item.id)"
									>
										<RepeatOulineIcon style="stroke:red;" />
									</span>
									<span
										v-if="
											data.item.status == 3 ||
												(data.item.status == 7 &&
													data.item.payment_method_id == bill_payment)
										"
										@click="downloadInvoice(data.item.id)"
									>
										<DownloadIcon v-if="loadingInvoice !== data.item.id" />
										<b-spinner
											v-else
											small
											label="Loading..."
											variant="'primary'"
										></b-spinner>
									</span>
								</div>
							</template>
						</b-table>
						<b-row cols="12" lg="12" class="text-center paginate-position">
							<div class="overflow-auto wrap-pagination d-none d-md-block">
								<b-pagination-nav
									v-model="page"
									class="paginate-item"
									:prev-text="$t('nextPg')"
									:next-text="$t('prevPg')"
									:link-gen="paginationNumber"
									:number-of-pages="
										pageInfo && pageInfo.pageCount ? pageInfo.pageCount : 1
									"
									use-router
								></b-pagination-nav>
							</div>
						</b-row>
					</div>
				</b-tab>
				<b-tab>
					<template v-slot:title>
						<HomeOutlineIcon />
						<span>{{
							$t('userDashboard.paymentHistory.changeBillingAddress')
						}}</span>
					</template>
					<div class="wrap-add-address">
						<b-row no-gutters>
							<div>
								<b-col cols="12">
									<div class="title">
										{{ $t('userDashboard.paymentHistory.formAddress.title') }}
									</div>
								</b-col>
								<b-col cols="12" class="mt-20">
									<InvoiceAddress />
								</b-col>
							</div>
						</b-row>
					</div>
				</b-tab>
			</b-tabs>
		</template>
		<b-modal id="modal-bill-send" centered hide-footer hide-header>
			<b-container fluid>
				<b-form
					class="needs-validation"
					novalidate
					id="form-add-address"
					@submit.prevent="sendInvoice"
				>
					<b-row class="mb-1 text-center" style="margin: 10px;">
						<div @click="hideModal" class="close-modal">
							<CloseIcon />
						</div>
						<div class="title">{{ $t('bill.title') }}</div>

						<div class="wrapper">
							<b-form-group>
								<div class="form-group">
									<label for>{{
										$t('userDashboard.paymentHistory.formAddress.name')
									}}</label>
									<b-form-input
										:placeholder="
											$t('userDashboard.paymentHistory.formAddress.name')
										"
										class="input-search price-input"
										v-model="sendFirstName"
										id="sendFirstName"
										:class="{ 'is-invalid': $v.sendFirstName.$error }"
									></b-form-input>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.frstName')
									}}</b-form-invalid-feedback>
								</div>
								<div class="form-group">
									<label for>{{
										$t('userDashboard.paymentHistory.formAddress.surname')
									}}</label>
									<b-form-input
										:placeholder="
											$t('userDashboard.paymentHistory.formAddress.surname')
										"
										class="input-search price-input"
										v-model="sendLastName"
										id="sendLastName"
										:class="{ 'is-invalid': $v.sendLastName.$error }"
									></b-form-input>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.lastName')
									}}</b-form-invalid-feedback>
								</div>
								<div class="form-group">
									<label for>{{
										$t('userDashboard.paymentHistory.formAddress.company')
									}}</label>
									<b-form-input
										:placeholder="
											$t('userDashboard.paymentHistory.formAddress.company')
										"
										class="input-search price-input"
										v-model="sendCompanyName"
										id="sendCompanyName"
										:class="{ 'is-invalid': $v.sendCompanyName.$error }"
									></b-form-input>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.company')
									}}</b-form-invalid-feedback>
								</div>
								<div class="form-group">
									<label for>{{
										$t('userDashboard.paymentHistory.formAddress.tax_id')
									}}</label>
									<b-form-input
										:placeholder="
											$t('userDashboard.paymentHistory.formAddress.tax_id')
										"
										class="input-search price-input"
										v-model="sendTaxId"
										id="sendTaxId"
										:class="{ 'is-invalid': $v.sendTaxId.$error }"
									></b-form-input>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.tax')
									}}</b-form-invalid-feedback>
								</div>
								<div class="form-group">
									<label for>{{ $t('bill.email') }}</label>
									<b-form-input
										:placeholder="$t('bill.email')"
										class="input-search price-input"
										v-model="sendEmail"
										id="sendEmail"
										:class="{ 'is-invalid': $v.sendEmail.$error }"
									></b-form-input>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.email')
									}}</b-form-invalid-feedback>
								</div>
								<div class="form-group">
									<label for>{{ $t('bill.address') }}</label>
									<b-form-textarea
										:placeholder="$t('bill.addressPlaceHolder')"
										class="input-search"
										v-model="sendAddress"
										id="sendAddress"
										:class="{ 'is-invalid': $v.sendAddress.$error }"
									></b-form-textarea>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.address')
									}}</b-form-invalid-feedback>
								</div>
							</b-form-group>
						</div>
						<div class="wrap-btn-send">
							<b-button class="cancel" id="cancel" @click="hideModal">{{
								$t('bill.cancel')
							}}</b-button>
							<b-button class="btn-send" id="save" type="submit">{{
								$t('bill.save')
							}}</b-button>
						</div>
					</b-row>
				</b-form>
			</b-container>
		</b-modal>
		<!-- MOBILE -->
		<template v-if="isMobile">
			<PaymentMobile
				:userPayments="userPayments"
				:bill_payment="bill_payment"
			/>
			<b-row cols="12" lg="12" class="text-center paginate-position">
				<div class="overflow-auto wrap-pagination d-none d-md-block">
					<b-pagination-nav
						v-model="page"
						class="paginate-item"
						:prev-text="$t('nextPg')"
						:next-text="$t('prevPg')"
						:link-gen="paginationNumber"
						:number-of-pages="
							pageInfo && pageInfo.pageCount ? pageInfo.pageCount : 1
						"
						use-router
					></b-pagination-nav>
				</div>
			</b-row>
		</template>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import * as actionType from '@/controllers/ActionTypes';
import InvoiceAddress from '@/components/invoices/Address';
import { required, email, integer, minLength } from 'vuelidate/lib/validators';
const moment = require('moment');

import PaymentMobile from './mobile/UserPaymentMobile';
// Icons
// import CloseIcon from 'vue-material-design-icons/Close.vue';
import FileDocumentOutlineIcon from 'vue-material-design-icons/FileDocumentOutline.vue';
import HomeOutlineIcon from 'vue-material-design-icons/HomeOutline.vue';
import RepeatOulineIcon from '@/components/icons/IconRepeat/index';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import DownloadIcon from '@/components/icons/IconDownload/index';
import SendOutlineIcon from 'vue-material-design-icons/SendOutline.vue';

export default {
	name: 'userPayment',
	components: {
		FileDocumentOutlineIcon,
		HomeOutlineIcon,
		RepeatOulineIcon,
		SendOutlineIcon,
		ChevronDownIcon,
		PaymentMobile,
		// CloseIcon,
		InvoiceAddress,
		DownloadIcon
	},
	data() {
		return {
			userPayments: [],
			searchQuery: '',
			awaitingSearch: false,
			orderByFilters: [
				{
					key: 'Date',
					value: this.$i18n.t('userDashboard.paymentHistory.fieldsPayment.date')
				},
				{
					key: 'Price',
					value: this.$i18n.t(
						'userDashboard.paymentHistory.fieldsPayment.amount'
					)
				}
			],
			loading: false,
			loadingInvoice: 0,
			fields: [
				{
					key: 'id',
					label: this.$i18n.t(
						'userDashboard.paymentHistory.fieldsPayment.receiptNumber'
					)
				},
				{
					key: 'created_at_day',
					label: this.$i18n.t('userDashboard.paymentHistory.fieldsPayment.date')
				},
				{
					key: 'created_at_time',
					label: this.$i18n.t('userDashboard.paymentHistory.fieldsPayment.time')
				},
				{
					key: 'total_amount',
					label: this.$i18n.t(
						'userDashboard.paymentHistory.fieldsPayment.amount'
					)
				},
				{
					key: 'status',
					label: this.$i18n.t(
						'userDashboard.paymentHistory.fieldsPayment.status'
					),
					tdClass: 'status-payment'
				},
				{ key: 'tooltip', label: '', tdClass: 'tooltip-table' }
			],
			selectedPaymentId: 0,
			showInfoTexInvoiceAddress: false,
			page: this.$route.params.id ? this.$route.params.id : 1,
			pageInfo: { take: 10, itemCount: 0, page: 1, pageCount: 0 },
			sendAddress: '',
			sendFirstName: '',
			sendLastName: '',
			sendCompanyName: '',
			sendTaxId: '',
			sendEmail: ''
		};
	},
	computed: {
		...mapGetters({
			isMobile: 'UserController/isMobile'
		}),
		...mapState('PaymentController', [
			'card_payment',
			'banking_payment',
			'bill_payment',
			'paypal_payment',
			'coin_payment',
			'true_money',
			'prompt_pay'
		])
	},
	validations: {
		sendAddress: { required, min: minLength(2) },
		sendEmail: { required, min: minLength(2), email },
		sendFirstName: { required, min: minLength(2) },
		sendLastName: { required, min: minLength(2) },
		sendCompanyName: { min: minLength(2) },
		sendTaxId: { min: minLength(3) }
	},
	watch: {
		searchQuery: function(val) {
			this.loading = true;
			this.page = 1;
			if (!this.awaitingSearch) {
				setTimeout(() => {
					this.fetchUserPayments();
					this.awaitingSearch = false;
				}, 1000); // 1 sec delay
			}
			this.awaitingSearch = true;
		},
		page: function(val) {
			this.fetchUserPayments();
		}
	},
	mounted: function() {
		this.fetchUserPayments();
	},
	filters: {
		formatDate(value, lang) {
			if (!value) return;
			let now = moment(new Date());
			let newVal = moment(value);
			// if(now.isSame(newVal, 'day')) return
			return moment(value)
				.local('th')
				.format('DD MMM YYYY');
		},
		formatHour(value, lang) {
			if (!value) return;
			return moment(value)
				.local('th')
				.format('HH:mm');
		}
	},
	methods: {
		...mapActions('PaymentController', [
			actionType.FETCH_USER_PAYMENTS,
			actionType.GENERATE_INVOICE,
			actionType.SEND_INVOICE
		]),
		fetchUserPayments(orderBy) {
			var vm = this;
			vm.loading = true;
			this.FETCH_USER_PAYMENTS({
				order_id: vm.searchQuery ? vm.searchQuery : undefined,
				orderBy: orderBy,
				page: vm.page
			}).then(function(result) {
				vm.userPayments = result.data;
				vm.pageInfo = result.meta;
				vm.loading = false;
			});
		},

		tryPayment(userPaymentId) {
			this.$router.push({
				name: 'Payment',
				params: {
					id: userPaymentId
				}
			});
		},
		downloadInvoice(userPaymentId) {
			var vm = this;
			vm.loadingInvoice = userPaymentId;
			this.GENERATE_INVOICE({
				id: userPaymentId
			}).then(function(result) {
				var fileURL = window.URL.createObjectURL(new Blob([result.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'invoice.pdf');
				document.body.appendChild(fileLink);

				fileLink.click();
				vm.loadingInvoice = 0;
			});
		},
		saveTexInvoiceAddress() {
			this.showInfoTexInvoiceAddress = true;
		},
		modifyTexInvoiceAddress() {
			this.showInfoTexInvoiceAddress = false;
		},
		openSendDialog(paymentId) {
			this.selectedPaymentId = paymentId;
			this.$bvModal.show('modal-bill-send');
		},
		sendInvoice() {
			this.$v.$touch();

			if (this.$v.$error) {
				return;
			}
			var vm = this;
			vm.$root.loading = true;
			vm.loadingInvoice = vm.userPaymentId;
			const data = {
				id: vm.selectedPaymentId,
				address: vm.sendAddress,
				email: vm.sendEmail,
				first_name: vm.sendFirstName,
				last_name: vm.sendLastName,
				company_name: vm.sendCompanyName,
				taxid: vm.sendTaxId
			};
			this.SEND_INVOICE(data)
				.then(result => {
					vm.loadingInvoice = 0;
					vm.$root.loading = false;
					vm.hideModal();
					vm.$bvToast.toast(
						this.$t('userDashboard.paymentHistory.invoiceSentToEmail'),
						{
							title: this.$t('userDashboard.paymentHistory.invoiceSentToEmail'),
							variant: 'success',
							solid: true
						}
					);
				})
				.catch(err => {
					vm.$root.loading = false;
					vm.$bvToast.toast(
						this.$t('userDashboard.paymentHistory.btnMobile.tryAgain'),
						{
							title: this.$t('userDashboard.paymentHistory.btnMobile.tryAgain'),
							variant: 'danger',
							solid: true
						}
					);
				});
		},
		hideModal() {
			this.$bvModal.hide('modal-bill-send');
		},
		paginationNumber(pageNum) {
			return pageNum === 1 ? '?page=1' : `?page=${pageNum}`;
		}
	}
};
</script>
<style lang="scss">
@import 'userPayment.scss';
</style>
